import { useEffect, useState } from "react";
import { useGetPermissions } from "react-admin";
import { isNil } from "lodash/fp";

import useCurrentUser from "./useCurrentUser";

/**
 * this hook won't work outside react admin 'Admin' component
 * will return 'undefined', so use it inside
 * */
const useGetUserRole = () => {
  const { user } = useCurrentUser();
  const [role, setRole] = useState(user.permissions && user.permissions.role);
  const res = useGetPermissions();

  useEffect(() => {
    (async function () {
      const permissions = await res();
      const _role = permissions && permissions.role;
      if (_role !== role && !isNil(_role)) setRole(_role);
    })();
  }, []);

  return { role };
};

export default useGetUserRole;
